
export default class DpWpLinkQuery {
	constructor(search, config) {
		if (config.dpDebugEn) console.log('[dpit] INIT DpWpLinkQuery');
		this.config = config;
		this.page = 1;
		this.allLoaded = false;
		this.querying = false;
		this.search = search;
		this.init();
	}

	init() {
		$.extend(DpWpLinkQuery.prototype, {
			ready() {
				return !(this.querying || this.allLoaded);
			},
			ajax(callback) {
				const self = this;
				const query = {
					action: 'dp-wp-link-ajax',
					page: this.page,
					_dp_wplink_nonce: this.config._dp_wplink_nonce,
				};
				if (this.search) query.search = this.search;

				this.querying = true;

				$.post(this.config.ajaxUrl, query, (r) => {
					self.page++;
					self.querying = false;
					self.allLoaded = !r;
					callback(r, query);
				}, 'json');
			},
		});
	}
}